import { IConventionPoll, IConventionPollResponse } from '@fg-types/convention-poll.type';
import { DeleteResponse } from '@fg-types/delete-response';
import { PaginatedResponse } from '@fg-types/paginated-response';
import { Observable } from 'rxjs';
import { ApiBase } from './api-base';

export class ConventionPollsApi extends ApiBase {
  model = 'ConventionPolls';

  createPoll(poll: Partial<IConventionPoll>) {
    return this.http.post<IConventionPoll>(`${this.modelBase}`, poll);
  }

  updatePoll(id: string, poll: Partial<IConventionPoll>) {
    return this.http.patch<IConventionPoll>(`${this.modelBase}/${id}`, poll);
  }

  deletePoll(id: string, conventionId: string) {
    return this.http.delete<DeleteResponse>(`${this.modelBase}/${id}?conventionId=${conventionId}`);
  }

  getPollById(id: string) {
    return this.http.get<IConventionPoll>(`${this.modelBase}/${id}`);
  }

  getConventionPolls(
    conventionId: string,
    pollStatus?: string,
    lastKey?: string,
    limit?: number
  ) {
    return this.http.get<PaginatedResponse<IConventionPoll>>(
      `${this.modelBase}/convention/${conventionId}`,
      {
        params: this.setParams({ pollStatus, lastKey, limit })
      }
    );
  }

  getConventionDraftPolls(conventionId: string, lastKey?: string) {
    return this.http.get<PaginatedResponse<IConventionPoll>>(
      `${this.modelBase}/convention/${conventionId}`,
      {
        params: this.setParams({ pollStatus: 'draft', isDrafted: true, lastKey })
      }
    );
  }

  submitPollResponse(response: Partial<IConventionPollResponse>) {
    return this.http.post<IConventionPollResponse>(`${this.modelBase}/responses`, response);
  }

  getPollResponses(pollId: string, lastKey?: string) {
    return this.http.get<PaginatedResponse<IConventionPollResponse>>(
      `${this.modelBase}/${pollId}/responses`,
      {
        params: this.setParams({ lastKey })
      }
    );
  }

  getPollResults(pollId: string) {
    return this.http.get<IConventionPoll>(`${this.modelBase}/${pollId}/results`);
  }

  getPollAnalytics(conventionId: string){
    return this.http.get<any>(`${this.modelBase}/Convention/${conventionId}/analytics`);
  }
}
